import { readString } from "react-papaparse";

/**
 * Converts a CSV file to JSON format
 * @param file CSV file to parse
 * @returns Promise with parsed JSON data
 */
export const csv2json = (
  file: File,
  headerKey?: string
): Promise<Record<string, string>> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      let text = e.target?.result as string;

      if (text.charCodeAt(0) === 0xfeff) {
        text = text.slice(1);
      }

      text = text.replace(/^"?sep=,?"?\r?\n/, "");

      if (headerKey) {
        const lines = text.split(/\r?\n/);
        const headerIndex = lines.findIndex((line) =>
          line.trim().startsWith(headerKey)
        );

        if (headerIndex === -1) {
          reject(new Error("CSV header 'originalString' not found"));
          return;
        }

        text = lines.slice(headerIndex).join("\n");
      }

      // Parse CSV using react-papaparse
      readString(text, {
        header: true,
        skipEmptyLines: true,
        delimiter: "",
        transform: (value) => value.trim(),
        complete: (results) => {
          const records: Record<string, string> = {};

          results.data.forEach((row: any) => {
            if (row.originalString && row.translation) {
              records[row.originalString] = row.translation;
            }
          });

          resolve(records);
        },
        error: (error) => {
          reject(new Error(`CSV Parse Error: ${error.message}`));
        },
      });
    };
    reader.onerror = () => reject(new Error("Failed to read file"));
    reader.readAsText(file, "utf-8");
  });
};

export default csv2json;
